import { Component, OnInit, ViewEncapsulation, Input, QueryList, ContentChildren, Output, EventEmitter, ElementRef } from '@angular/core';
import { ListItemDetailComponent } from '../list-item-detail/list-item-detail.component';
import { ListComponent } from '../list-container/list.component';

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ListItemComponent implements OnInit {

  @Input() expanded = false;
  @Input() model: any;

  @Output() valueChange = new EventEmitter();

  @ContentChildren(ListItemDetailComponent) children: QueryList<ListItemDetailComponent>;

  selected = false;

  /** The encapsulating list component. */
  private list: ListComponent;
  private self: ElementRef;

  constructor(self: ElementRef,
              list: ListComponent) {
    this.list = list;
    this.self = self;
  }

  /** Called, if the user clicks on the list item content. */
  handleClick() {
    this.notifySelect();
    this.expandDetails();
  }

  expandDetails() {
    this.expanded = true;
  }

  collapseDetails() {
    this.expanded = false;
  }

  /** We have to inform our parent list about a change in selection. */
  notifySelect() {
    this.list.selections.select(this.model);
  }

  hasItemDetails(): boolean {
    return this.children !== null && this.children.length > 0;
  }

  ngOnInit() {
    /** Maybe there is already a selected entry. So we check this first. */
    const selectedEntries = this.list.selections.selected;
    this.checkSelected(selectedEntries);
    /** Register now for future list selection changes. We have to collapse the detail area, if another item is selected. */
    this.list.selections.changed.subscribe(selectionModel => {
      this.checkSelected(selectionModel.source.selected);
      if (this.selected) {
        this.expandDetails();
        if(this.outsideView()) {
          this.scrollTo();
        }
      }
    });
  }

  private outsideView(): boolean {
    const outside = this.isOutsideView(this.self.nativeElement);
    return outside.bottom || outside.top;
  }

  private isOutsideView(elem): any {
    const bounding = elem.getBoundingClientRect();
    return {
      top : bounding.top < 0,
      bottom : bounding.bottom > (window.innerHeight || document.documentElement.clientHeight)
    };
  }

  private scrollTo() {
    this.self.nativeElement.scrollIntoView();
  }

  private checkSelected(selectedValues) {
    let foundItem = null;
    if (selectedValues != null && selectedValues.length > 0) {
      selectedValues.forEach((item) => {
        if (item != null && JSON.stringify(item) === JSON.stringify(this.model)) {
          foundItem = item;
          this.selected = true;
        }
      });
    }
    if (foundItem === null) {
      this.selected = false;
      this.collapseDetails();
    }
  }

}
